import { config } from '../lib/config'
import { BrandMark } from './BrandMark'
import { ServerStatus } from './ServerStatus'

import { Link } from '../lib/router'

export function Footer() {
  return (
    <footer className="footer">
      <span className="footer__brand">
        <BrandMark muted />
      </span>
      <div className="flex flex-col items-center gap-2">
        <p>© 2026 BlastCore TNTWars.</p>
        <div className="flex gap-4 text-xs text-neutral-500">
          <Link to="/privacy" className="hover:text-neutral-300 transition-colors">Privacy</Link>
          <Link to="/terms" className="hover:text-neutral-300 transition-colors">Termini</Link>
          <Link to="/cookies" className="hover:text-neutral-300 transition-colors">Cookie</Link>
        </div>
      </div>
      <div className="footer__status">
        <span>{config.serverIp}</span>
        <ServerStatus />
      </div>
    </footer>
  )
}
